<template>
  <div class="flex vz-requirements-checkbox">
    <vz-checkbox
      v-if="modelValue"
      :modelValue="modelValue.active"
      :label="modelValue.title"
      @update:modelValue="onChange"
    >
      <template #label>
        <span class="vz-checkbox-label">{{ modelValue.title }}</span>
        <vz-tooltip-info
          class="ml-5"
          :instantHide="tooltipsInstantHide"
        >
          <template #baloon>
            <span v-html="modelValue.tooltip" />
          </template>
        </vz-tooltip-info>
      </template>
    </vz-checkbox>
  </div>
</template>
<script setup lang="ts">
import {SpecialRequirementsCheckbox} from '~/types/types';
import {PropType} from 'vue';
import VzCheckbox from '~/components/ui-kit/vz-checkbox.vue';

const emit = defineEmits(['change'])

const props = defineProps({
  modelValue: {
    type: Object as PropType<SpecialRequirementsCheckbox>,
    default: () => ({ required: true, default: null })
  },
  tooltipsInstantHide: {
    default: false,
    type: Boolean
  }
})

function onChange (value: boolean) {
  emit('change', value)
}
</script>
